import { render, staticRenderFns } from "./appFormEdit.vue?vue&type=template&id=550d066c"
import script from "../../controllers/application_form/app-form-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/application_form/app-form-edit.js?vue&type=script&lang=js&external"
import style0 from "./appFormEdit.vue?vue&type=style&index=0&id=550d066c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports